module.exports = {"130631100":"望都镇","130631101":"固店镇","130631102":"贾村镇","130631200":"寺庄乡","130631201":"赵庄乡","130631202":"黑堡乡","130631204":"高岭乡","130631205":"中韩庄乡","130631400":"望都经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130631.json
// module id = 149
// module chunks = 0